import { Flex, Link, Text } from '@servicetitan/anvil2';

interface ServiceFinanceDisclosureTextProps {
    onOpenNotice: (notice: 'ElectronicRecordsDisclosure' | 'GeneralApplicationDisclosure') => void;
}

export const ServiceFinanceDisclosureText = ({
    onOpenNotice,
}: ServiceFinanceDisclosureTextProps) => {
    return (
        <Flex direction="column" gap="4">
            <Text variant="body">
                By checking the box above and clicking "Continue" below, you are providing written
                instruction to Service Finance Company, LLC to obtain your consumer credit report
                from one or more consumer reporting agencies to evaluate your request for
                prequalification. You agree that the information that you are providing is true,
                correct and accurate to the best of your knowledge, and that you are at least 18
                years of age. You understand that by submitting this request for prequalification
                that Service Finance Company may perform one or more soft credit inquiries to
                consumer reporting agencies which will not affect your credit score.
            </Text>

            <Text variant="body">
                If you choose to continue your application, then Service Finance will request a full
                credit report from one or more consumer reporting agencies, which will be a "hard"
                credit pull which can affect your credit score and can be seen by third parties. A
                prequalification approval is not a guaranty of a full application approval. Please
                read the following important notices from Service Finance before submitting your
                request for prequalification:{' '}
                <Link onClick={() => onOpenNotice('ElectronicRecordsDisclosure')}>
                    Service Finance's Electronic Records Disclosure and Consent
                </Link>
                ,{' '}
                <Link onClick={() => onOpenNotice('GeneralApplicationDisclosure')}>
                    General Application Disclosures
                </Link>
                ,{' '}
                <Link
                    target="_blank"
                    href="https://www.ftc.gov/legal-library/browse/rules/childrens-online-privacy-protection-rule-coppa"
                >
                    COPPA Disclosure
                </Link>
                ,{' '}
                <Link target="_blank" href="https://www.svcfin.com/pages/privacy.notice/">
                    Privacy Notice
                </Link>
                , and for California residents,{' '}
                <Link
                    target="_blank"
                    href="https://www.svcfin.com/pages/privacy.notice.collection/"
                >
                    Consumer Rights Notice
                </Link>
                .
            </Text>

            <Text variant="body">
                By clicking "Submit Application", you acknowledge and agree to the terms contained
                in these notices.
            </Text>
        </Flex>
    );
};
